export default __webpack_public_path__ + "static/media/youtube.bbffe782.svg";